import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { serviceIcon, serviceLabel, STATUS_LABEL, formatZAR } from "@/lib/constants";

export default function AdminJobs() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/requests").then(({ data }) => setItems(data));
  }, []);
  return (
    <div>
      <div className="px-6 pt-8 pb-4">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Admin</div>
        <h1 className="font-display text-3xl font-black tracking-tight">All Requests</h1>
        <p className="text-sm text-[#9CA3AF] mt-1">{items.length} total</p>
      </div>
      <div className="px-6 pb-6 space-y-2">
        {items.map((r) => (
          <Link key={r.id} to={`/app/request/${r.id}`} className="block border border-white/10 rounded-md p-3 hover:border-white" data-testid={`admin-job-${r.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex gap-3">
                <div className="text-2xl">{serviceIcon(r.serviceType)}</div>
                <div>
                  <div className="font-display font-bold text-sm">{serviceLabel(r.serviceType)}</div>
                  <div className="text-xs text-[#9CA3AF]">{r.clientName} → {r.mechanicName || "unassigned"}</div>
                  <div className="text-xs text-[#9CA3AF]">{new Date(r.created_at).toLocaleString()}</div>
                </div>
              </div>
              <div className="text-right">
                <span className={`status-pill status-${r.status}`}>{STATUS_LABEL[r.status]}</span>
                <div className="font-display font-bold text-sm mt-1">{formatZAR(r.price)}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
